import { a as __rest } from '../../tslib.es6.esm.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useId, useMemo } from 'react';
import * as RadioGroup from '@radix-ui/react-radio-group';
import radioButtonStyles from '../BaseRadioButton/BaseRadioButton.styles.esm.js';
import radioButtonStyles$1 from './RadioButton.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

/**
 * RadioButton component allows users to select one option from a set.
 * This component is composed from BaseRadioButton and BaseLabel.
 */
const RadioButton = (props) => {
    const generatedId = useId();
    const { id = generatedId, className = "", inverse = false, error = false, disabled = false, "aria-label": ariaLabel, label, value, onClick } = props, otherProps = __rest(props, ["id", "className", "inverse", "error", "disabled", "aria-label", "label", "value", "onClick"]);
    const { base: radioBaseStyles, indicator } = radioButtonStyles({
        inverse,
        error,
        disabled,
    });
    const styles = useMemo(() => radioButtonStyles$1({
        inverse,
        error,
        disabled,
        class: className,
    }), [inverse, error, disabled, className]);
    const { base, label: labelStyles, radioWrapper } = styles;
    return (jsxs(RadioGroup.Item, Object.assign({ id: id, value: value, "aria-label": ariaLabel, onClick: onClick, disabled: disabled, className: cn(base(), className) }, otherProps, { children: [jsx("div", { className: radioWrapper(), children: jsx("div", { className: cn(radioBaseStyles(), className), children: jsx(RadioGroup.Indicator, { className: indicator() }) }) }), label && jsx("span", { className: labelStyles(), children: label })] })));
};
RadioButton.displayName = "RadioButton";

export { RadioButton };
